export default {
    loading: false,
    error: null,
    tags: [],
}
